import { render } from "./ALogistikaHomePage.vue?vue&type=template&id=01ade7b8&scoped=true"
import script from "./ALogistikaHomePage.vue?vue&type=script&lang=js"
export * from "./ALogistikaHomePage.vue?vue&type=script&lang=js"

import "./ALogistikaHomePage.vue?vue&type=style&index=0&id=01ade7b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ade7b8"]])

export default __exports__